import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { createEmbeddingContext, EmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { take } from 'rxjs';

import { AuxQuickSightDashboardType, GqlService } from '@shared/services/gql.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aux-quicksight-portfolio-dashboard',
  templateUrl: './quicksight-dashboard.component.html',
})
export class QuickSightDashboardComponent implements OnInit {
  private gqlService = inject(GqlService);

  ngOnInit() {
    this.getDashboardURL();
  }

  async getDashboard(embeddedURL: string) {
    const containerDiv = document.getElementById('dashboardContainer') || '';
    const frameOptions = {
      container: containerDiv,
      height: '850px',
      resizeHeightOnSizeChangedEvent: true,
      url: embeddedURL,
      width: '100%',
    };
    const embeddingContext: EmbeddingContext = await createEmbeddingContext();

    void embeddingContext.embedDashboard(frameOptions);
  }

  getDashboardURL() {
    this.gqlService
      .generateEmbeddedQuickSightURL$(AuxQuickSightDashboardType.PORTFOLIO)
      .pipe(take(1))
      .subscribe(({ data }) => void this.getDashboard(data?.url || ''));
  }
}
